<template>
  <div class="mt-3">
    <b-form>
      <b-row>
        <b-col xl="12" lg="12" sm="12">
          <b-input-group prepend="IMSI" label-for="input-1">
            <b-form-input
                :state="true"
                v-model="suspendSubscriberForm.imsiInfo"
                required
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <hr>
      <b-row class="mt-3">
        <b-col xl="6" md="6" sm="6">
          <div class="float-left">
            <base-button type="white" title="Close" v-on:click="modalClose()">
              Close
            </base-button>
          </div>
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <div class="float-right">
            <base-button type="primary" title="Submit" :disabled="submitDisabled" v-on:click="suspendSubscriberSubmit()">
              Submit
            </base-button>
          </div>
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>

<script>
import provisioningService from "../../common/api-services/provisioning-service";
import ToastVue from "./Toast.vue";
import configDirective from "@/common/directive/config-directive";
import commonService from "@/common/api-services/common";
import AuthService from "../../common/api-services/auth-service";

export default {
  name: "Suspend-Subscriber",
  components: {ToastVue},
  data() {
    return {
      suspendSubscriberForm: {
        imsiInfo: ''
      }
    }
  },
  computed: {
    submitDisabled() {
      return !this.suspendSubscriberForm.imsiInfo.length > 0;
    }
  },
  mounted() {
    this.$root.$on('sendIMSIInfo', (imsi => {
      this.suspendSubscriberForm.imsiInfo = imsi;
    }))
  },
  methods: {
    async suspendSubscriberSubmit() {

      //do the IOT version
      if (configDirective.isIOTOnly()) {

        provisioningService.submitSimpleSuspend(this.suspendSubscriberForm.imsiInfo).then(res => {
          if (res) {
            this.$toast.success({
              component: ToastVue,
              props: {
                title: 'Suspend Subscriber: OK',
                description: res.join("<br>")
              }
            }, {
              timeout: 5000
            })
            this.modalClose();
          } else {
            this.$toast.error({
              component: ToastVue,
              props: {
                title: 'Suspend Subscriber: FAILED',
                description: res.join("<br>")
              }
            }, {
              timeout: 5000
            })
          }
        }).catch(err => {
          this.$toast.error({
            component: ToastVue,
            props: {
              title: 'Suspend Subscriber: FAILED',
              description: JSON.stringify(err)
            }
          }, {
            timeout: 5000
          })
        });

      } else {
        this.$root.$emit('loadingPanelShow', true);

        await provisioningService.submitSuspendSubscriber(this.suspendSubscriberForm.imsiInfo).then(res => {
          if (res && res.success) {
            this.addLog(res.success, 0);
            let messageData = '<br>';
            res.success.map(item => {
              messageData = messageData + item + `<br>`
            });
            this.$toast.success({
              component: ToastVue,
              props: {
                title: 'Suspend Subscriber: OK',
                description: JSON.stringify(res.data) //messageData.join("<br>")
              }
            }, {
              timeout: 5000
            })
            this.modalClose();
          } else {
            this.addLog(res.data, 1);
            this.$toast.error({
              component: ToastVue,
              props: {
                title: 'Suspend Subscriber: FAILED',
                description: JSON.stringify(res.data)
              }
            }, {
              timeout: 5000
            })
          }
        }).catch(err => {
          // this.addLog(err, 1);
          this.$toast.error({
            component: ToastVue,
            props: {
              title: 'Suspend Subscriber: FAILED',
              description: JSON.stringify(err)
            }
          }, {
            timeout: 5000
          })
        });
      }

    },

    addLog(details, isError=0) {
      AuthService.setActivityLog("Mobility: Suspend Subscriber", details, isError)
    },

    modalClose() {
      setTimeout(() => {
        //this.progressMessage = 'Refreshing Subscriber data...';

        //window.location.reload();
        this.$forceUpdate();

        this.$root.$emit('reloadSimDetailPageData', this.suspendSubscriberForm.imsiInfo);

        this.$bvModal.hide('suspend-subscriber');
        this.$root.$emit('loadingPanelHide', true);
      }, 1000);
    },

  }
}
</script>
